/**
 * AuthProvider — thin wrapper over MsalProvider (ADR-3).
 *
 * In production: wraps children in MsalProvider so every component can call
 * useMsal(), useIsAuthenticated(), etc.
 *
 * In dev mode with devAuthEnabled: still renders MsalProvider (MSAL is
 * initialized but no real sign-in is required — the dev role switcher supplies
 * a synthetic identity to RequireRole). Children always render so the reviewer
 * screens can be exercised without a live Entra tenant.
 *
 * Note: initializeMsal() must be called (and awaited) in main.tsx before the
 * React tree renders so that handleRedirectPromise() completes first. F4 owns
 * that call.
 */

import { MsalProvider } from '@azure/msal-react';
import type { ReactNode } from 'react';
import { msalInstance } from '@/config/auth';

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Mount this above FluentProvider in the provider stack (F4 wires the order).
 * Provider order: QueryClientProvider → AuthProvider → FluentProvider → RouterProvider.
 */
export function AuthProvider({ children }: AuthProviderProps) {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}

export default AuthProvider;
